import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const {
  getFinancialOperations,
  approveOperation,
  declineOperation,
  getFinancialOperationsSelf,
  getBulkFinancialOperations,
  getMyBulkFinancialOperations,
} = endpoints;

const financialOperations = async (params: any) => {
  try {
    const response = await axios.get(getFinancialOperations, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const bulkFinancialOperations = async (params: any) => {
  try {
    const response = await axios.get(getBulkFinancialOperations, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const myBulkFinancialOperations = async (params: any) => {
  try {
    const response = await axios.get(getMyBulkFinancialOperations, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const approveFinancialOperation = async (data: any) => {
  try {
    const response = await axios.post(approveOperation, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const declineFinancialOperation = async (data: any, reason: string) => {
  try {
    const response = await axios.put(declineOperation, { data, reason });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const myTransactions = async (params: any) => {
  try {
    const response = await axios.get(getFinancialOperationsSelf, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const financialOperationsServices = {
  financialOperations,
  approveFinancialOperation,
  declineFinancialOperation,
  myTransactions,
  bulkFinancialOperations,
  myBulkFinancialOperations,
};

export default financialOperationsServices;
